import { render, staticRenderFns } from "./DiscapacidadIntelectual.vue?vue&type=template&id=4d6000d5&scoped=true"
import script from "./DiscapacidadIntelectual.vue?vue&type=script&lang=js"
export * from "./DiscapacidadIntelectual.vue?vue&type=script&lang=js"
import style0 from "./DiscapacidadIntelectual.vue?vue&type=style&index=0&id=4d6000d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6000d5",
  null
  
)

export default component.exports